/**
 * @description
 */

import {fetchData} from '@umu/umu-fetch';

import Api from '../../../../path';

export interface IInput {
    practice_id: number;
    page: number;
    size?: number;
}

export interface IOutput {
    element_id: number;
    question_id: number;
    element_type: number;
}

export const getQuestionIdList = (data: IInput): Promise<IListResponse<IOutput>> => {
    return fetchData(Api.QUESTION_COLLECTION_GET_QUESTION_ID_LIST, data).then((res: IListResponse<IOutput>) => {
        return res;
    });
};
